import React from 'react';

interface SelectionBorderProps {
  isDragging: boolean;
  isKeyboardFocused: boolean;
}

export default function SelectionBorder({
  isDragging,
  isKeyboardFocused,
}: SelectionBorderProps) {
  return (
    <div
      className={`absolute inset-0 border-2 transition-colors duration-150 border-b-0 ${
        isDragging ? 'border-yellow-300' : 'border-yellow-400'
      }`}
      style={{
        boxShadow: isDragging
          ? '0 0 20px rgba(251, 191, 36, 0.4), inset 0 0 0 1px rgba(251, 191, 36, 0.2)'
          : isKeyboardFocused
          ? '0 0 15px rgba(251, 191, 36, 0.5), inset 0 0 0 1px rgba(251, 191, 36, 0.3)'
          : '0 0 10px rgba(251, 191, 36, 0.3)',
      }}
    />
  );
}
